//#region src/modules/Users/shared/AccessAndPermissions/constants.ts
var ACCESS_AND_PERMISSIONS_LABELS = {
	ADMIN_ACCESS: { canViewEmailLogs: "Can View Email Logs" },
	ADMIN_PERMISSIONS: {
		manageEntryTypes: "Manage Entry Types",
		manageEvents: "Manage Events",
		manageLocations: "Manage Locations",
		manageOrganization: "Manage Organization",
		manageOrganizationSubscription: "Manage Organization Subscription",
		manageRecords: "Manage Records",
		manageRegions: "Manage Regions",
		manageReports: "Manage Reports",
		manageUsers: "Manage Users"
	},
	ADMIN_RESTRICTIONS: {},
	DISPATCH_ACCESS: {
		canDownloadAndExportData: `Can Download and Export OPS Data (PDF's, CSV, Excel, etc.)`,
		viewUserContactInfo: "View other Users contact info (email/phone/etc.)"
	},
	DISPATCH_PERMISSIONS: {
		canReopenEvents: "Can Reopen Events",
		createEvents: "Create Events",
		deleteEvents: "Delete Events",
		editEvents: "Edit Events",
		manageEventAssignments: "Manage Event Assignments"
	},
	DISPATCH_RESTRICTIONS: {},
	OPS_ACCESS: {
		canDownloadAndExportData: `Can Download and Export OPS Data (PDF's, CSV, Excel, etc.)`,
		viewAllUsersShifts: "View other Users Shifts",
		viewOnDutyUsersGeoLocation: `View other On-Duty Users GPS on Maps`,
		viewOpsSummary: "View OPS Summaries",
		viewUserActivity: "View other Users activity history",
		viewUserContactInfo: "View other Users contact info (email/phone/etc.)",
		viewUsersGeoLocationHistory: "View Users Geo Location history"
	},
	OPS_PERMISSIONS: {
		canBulkUploadRecords: "Can Bulk Upload Records",
		canBypassRequiredGPS: "Can Bypass Required GPS Restrictions",
		canBypassRequiredStatus: "Can Bypass Required Duty Status Restrictions",
		canDeactivateOtherUsersSOS: `Can Deactivate Other User's Activated SOS`,
		canReopenEvents: "Can Reopen Events",
		changeOtherUserStatus: "Change other User Statuses",
		contributeToOtherUserReports: "Contribute to other User Reports",
		createBolos: "Create BOLOs",
		createEvents: "Create Events",
		createLocationLogEntries: "Create Location Log Entries",
		createPassDowns: "Create Pass-Downs",
		createRecords: "Create Records",
		deleteEvents: "Delete Events",
		deleteRecords: "Delete Records",
		editEvents: "Edit Events",
		editLocationLogEntries: "Edit Location Log Entries",
		editOtherUserLocationLogEntries: "Edit other User Location Log Entries",
		editOtherUserReports: "Edit other User Reports",
		editPatrolRouteRuns: "Edit Patrol Route Runs",
		editRecords: "Edit Records",
		manageEventAssignments: "Manage Event Assignments"
	},
	OPS_RESTRICTIONS: {
		cannotViewOthersLocationLogEntries: `Cannot View other User's Location Log Entries`,
		mustBeAtLocationToCreateEditLogs: `Must be at Location to Create/Edit Location Log Entries & Checkpoints`,
		mustHaveDutyStatusForOPSUse: `Must have Duty Status set to use the OPS app`
	},
	PORTAL_ACCESS: {
		viewBolos: "View BOLOs",
		viewEvents: "View Events",
		viewLocationInfo: "View Location Info",
		viewLocationLogs: "View Location Logs",
		viewLocationMapDetails: "View Location map details",
		viewPassDowns: "View Pass-Downs",
		viewRecordComments: "View Record Comments",
		viewRecords: "View Records",
		viewReports: "View Reports",
		viewUserGps: "View User GPS breadcrumbs"
	},
	PORTAL_PERMISSIONS: {
		canManagePortalBolos: "Manage Portal BOLOs",
		canManagePortalPassDowns: "Manage Portal Pass-Downs",
		createBolos: "Create BOLOs",
		createPassDowns: "Create Pass-Downs",
		createRecordComments: "Comment on Records",
		createRecords: "Create Records",
		editRecords: "Edit Records"
	},
	PORTAL_RESTRICTIONS: {},
	SCHEDULING_ACCESS: {},
	SCHEDULING_PERMISSIONS: {
		canActOnBehalfOfOthers: "Can Interact with Shifts on Behalf of Others",
		canEditTimeLogs: "Can Edit Time Logs"
	},
	SCHEDULING_RESTRICTIONS: {},
	SENTINEL_ACCESS: { canViewSentinelApp: "Can View Sentinel App" },
	SENTINEL_PERMISSIONS: {
		canDispatch: "Can Dispatch Sentinel Events",
		canManageConfig: "Can Manage Sentinel Config"
	}
};
/**
* Portal permission keys currently surfaced in the Admin display & form. Only
* these portal permissions can be granted via the Admin UI; the remaining keys
* in PORTAL_PERMISSIONS stay hidden until they're ready to expose.
*/
var ADMIN_VISIBLE_PORTAL_PERMISSION_KEYS = ["canManagePortalBolos", "canManagePortalPassDowns"];
//#endregion
export { ACCESS_AND_PERMISSIONS_LABELS, ADMIN_VISIBLE_PORTAL_PERMISSION_KEYS };

//# sourceMappingURL=constants.js.map